import React, { useState } from 'react';
import FilterPopover from './filters/FilterPopover';
import { usePositions } from '@/hooks/usePositions';
import type { FilterState } from '@/types/filterTypes';
import { DEFAULT_FILTER_STATE, hasActiveFilters as checkActiveFilters } from '@/types/filterTypes';

interface AdminFiltersProps {
  submissions: any[];
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
  isExpanded: boolean;
  onToggleExpanded: () => void;
  compact?: boolean;
  expandedView?: boolean;
}

const AdminFilters: React.FC<AdminFiltersProps> = ({
  filters,
  onFiltersChange,
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { positions } = usePositions();

  const handleFilterChange = (key: keyof FilterState, value: string | string[] | { min: number; max: number } | 'include' | 'exclude') => {
    const newFilters = { ...filters, [key]: value };
    onFiltersChange(newFilters);
  };

  const resetFilters = () => {
    onFiltersChange(DEFAULT_FILTER_STATE);
    setPopoverOpen(false);
  };

  const activeFilters = checkActiveFilters(filters);

  return (
    <FilterPopover
      filters={filters}
      uniqueProfiles={[]}
      positions={positions.map(p => ({ id: p.id, name: p.name }))}
      onFilterChange={handleFilterChange}
      onResetFilters={resetFilters}
      hasActiveFilters={activeFilters}
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
    />
  );
};

export default AdminFilters;
